import React from 'react';
import { Layout as RALayout, CheckForApplicationUpdate } from 'react-admin';
import { AppBar } from './AppBar';
import { Menu } from './Menu';

export const Layout = ({ children }: { children: React.ReactNode }) => (
    <RALayout appBar={AppBar} menu={Menu}>
        {children}
        <CheckForApplicationUpdate />
    </RALayout>
);
